<!--suppress ALL -->

<template>
  <div>
    <el-button
      type="text"
      @click="dialogVisible = true"
    >高级搜索</el-button>
    <el-dialog
      class="filterDialog"
      title="高级搜索"
      width="700px"
      @close="resetData"
      :visible.sync="dialogVisible"
    >
      <el-scrollbar>
        <div class="maxHeight">
          <filter-card
            v-for="(item,index) in groups"
            :key="index"
            v-if="item.tagName !== 'sky-condition'"
            :title="!item.hideLabel && item.label"
          >
            <div
              size="medium"
              ref="formItem"
              no-search
              no-label
              delay
              v-model.trim="item.value"
              :is="item.tagName"
              @change="change(item,$event,groups)"
              v-bind="item"
              :data="item"
              border
            ></div>
          </filter-card>
          <!--<filter-card title="其他" >
            <div class="flex">
              <sky-condition v-for="(item, index) in getGroups"  v-if="item.tagName === 'sky-condition'" :key="index" v-bind="item" v-model="item.value"></sky-condition>
            </div>
          </filter-card>-->
        </div>
      </el-scrollbar>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="search"
        >搜 索</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash'
import formComponents from '@/components/iglobalwin/formComponents'
import filterCard from '../filterCard'
export default {
  components: {
    ...formComponents,
    filterCard
  },
  props: {
    advanceds: {
      default: null
    },
    labelPosition: {
      default: 'top',
      type: String
    },
    groups: {
      default: () => [],
      type: [Object, Array]
    }
  },
  data: function() {
    return {
      dialogVisible: false,
      originGroup: [],
      getGroups: []
    }
  },
  computed: {},
  mounted() {
    this.originGroup = this.formatVal()
    this.getGroups = this.formatVal()
  },
  watch: {
    groups: {
      handler(val) {
        this.originGroup = this.formatVal()
        this.getGroups = this.formatVal()
      },
      deep: true
    }
  },
  methods: {
    change() {
      this.$emit('modalChange', ...arguments)
    },
    formatVal() {
      let _multiples =
        (this.groups.multiples && _.cloneDeep(this.groups.multiples)) || []
      let _advanceds =
        (this.groups.advanceds && _.cloneDeep(this.groups.advanceds)) || []
      let _range =
        (this.groups.range &&
          _.assign({}, this.groups.range, {
            tagName: 'sky-range-input',
            noSearch: true
          })) ||
        {}
      let _condition = this.convertList(this.groups.condition, 'sky-condition')
      _multiples = _.map(_multiples, item => {
        return _.assign(item, { tagName: 'sky-dropdownSelect' })
      })
      let groups = [..._advanceds, ..._multiples, _range, ..._condition]
      groups = _.map(groups, item => {
        if (item.tagName === 'sky-range-input') {
          item = _.assign(item, { noLabel: true })
        }
        return item
      })
      return groups
    },
    convertList(list = [], name) {
      let _list = _.cloneDeep(list)
      _list = _.map(_list, item => {
        return _.assign(item, { tagName: name, noLabel: true })
      })
      return _list
    },
    search() {
      _.each(this.$refs.formItem, item => item.setVal && item.setVal())
      this.dialogVisible = false
      this.$emit('change', this.groups)
    },
    handleClose(done) {
      _.each(this.$refs.formItem, item => item.getVal && item.getVal())
      this.$emit('closeModal', done)
      done()
    },
    resetData() {
      _.each(this.$refs.formItem, item => item.getVal && item.getVal())
      this.getGroups = _.cloneDeep(this.originGroup)
    },
    getSearchList() {
      let obj = {}
      _.each(this.getGroups, (item, index) => {
        if (item.value) {
          obj[item.label] = item.value
        }
      })
      return obj
    },
    getFilterList() {}
  }
}
</script>
<style lang="scss" scoped>
.filterDialog ::v-deep  .el-dialog__header {
  font-weight: bold;
}
.filterDialog {
  & .el-dropdown {
    width: 100%;
  }
  & .el-input {
    width: 100%;
  }
  .maxHeight {
    max-height: 500px;
  }
}
.flex {
  display: flex;
  align-items: center;
}
.filterDialog ::v-deep  .el-dialog__body {
  padding-top: 15px;
}
.filterDialog ::v-deep  .el-input {
  width: 100%;
}
</style>
